<template>
  <v-content >
    <router-view/>
  </v-content>
</template>

<script>
  export default {
    components: {},
    created() {},
    data: () => ({}),
  };
</script>
